import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "section-card reschedule-card"
}
const _hoisted_2 = { class: "reschedule-header" }
const _hoisted_3 = { class: "reschedule-title-wrap" }
const _hoisted_4 = { class: "reschedule-icon" }
const _hoisted_5 = { class: "reschedule-schedule" }
const _hoisted_6 = { class: "reschedule-row" }
const _hoisted_7 = { class: "reschedule-row-icon" }
const _hoisted_8 = { class: "reschedule-row-value" }
const _hoisted_9 = { class: "reschedule-row" }
const _hoisted_10 = { class: "reschedule-row-icon" }
const _hoisted_11 = { class: "reschedule-row-value" }
const _hoisted_12 = {
  key: 0,
  class: "reschedule-reason"
}
const _hoisted_13 = { class: "reschedule-reason-text" }
const _hoisted_14 = { class: "reschedule-actions" }

import { computed, ref } from "vue";
import AppButtonFlat from "@/shared/components/ui/AppButtonFlat.vue";
import { useModalStore } from "@/shared/stores/modal";
import { formatDate, formatTime } from "@/shared/utils/utils";
import AppointmentRescheduleApproveModal from "@/modules/vendor/components/AppointmentRescheduleApproveModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppointmentRescheduleRequestCard',
  props: {
    appointment: {}
  },
  setup(__props: any) {

const props = __props;

const modal = useModalStore();
const isApproved = ref(false);
const reason = computed(() => props.appointment?.reschedule_request?.reason || "");
const preferredDateLabel = computed(() =>
  formatDate(props.appointment?.reschedule_request?.preferred_date || ""),
);
const preferredTimeLabel = computed(() =>
  formatTime(props.appointment?.reschedule_request?.preferred_time || ""),
);

function handleApproveClick() {
  modal.open(
    AppointmentRescheduleApproveModal,
    {
      appointment: props.appointment,
      onSuccess: () => {
        isApproved.value = true;
      },
    },
    { title: "Approve Reschedule" }
  );
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (!isApproved.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("mdi-calendar-refresh", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("div", null, [
              _createElementVNode("p", { class: "reschedule-title" }, "Reschedule Requested"),
              _createElementVNode("p", { class: "reschedule-subtitle" }, "The customer requested a new appointment time.")
            ], -1))
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "reschedule-badge" }, "Pending", -1))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_v_icon, { size: "16" }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("mdi-calendar", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("div", null, [
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "reschedule-row-label" }, "Preferred date", -1)),
              _createElementVNode("p", _hoisted_8, _toDisplayString(preferredDateLabel.value), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_v_icon, { size: "16" }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("mdi-clock-outline", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("div", null, [
              _cache[6] || (_cache[6] = _createElementVNode("p", { class: "reschedule-row-label" }, "Preferred time", -1)),
              _createElementVNode("p", _hoisted_11, _toDisplayString(preferredTimeLabel.value), 1)
            ])
          ])
        ]),
        (reason.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _cache[7] || (_cache[7] = _createElementVNode("p", { class: "reschedule-reason-label" }, "Reason", -1)),
              _createElementVNode("p", _hoisted_13, _toDisplayString(reason.value), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(AppButtonFlat, {
            block: "",
            color: "success",
            "prepend-icon": "mdi-check-circle-outline",
            onClick: handleApproveClick
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode(" Approve Request ", -1)
            ]))]),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})